module.exports = __webpack_public_path__ + "static/media/line-varied-dashed-white.787ab465.svg";